









import { mapState, mapActions } from 'vuex';
import { Component, Vue } from 'vue-property-decorator';

@Component ({
	methods: mapActions (['clearMessage'])
})
export default class AlertMessage extends Vue
{
	get message ()
	{
		return this.$store.state.message;
	}
	get nextUrl ()
	{
		return this.$store.state.message && this.$store.state.message.nextUrl;
	}
	get isError ()
	{
		return this.message && this.message.error;
	}
	get isSuccess ()
	{
		return this.message && !this.message.error;
	}

	goNext ()
	{
		if (this.nextUrl)
			window.location = this.nextUrl;
		else
			// @ts-ignore
			this.clearMessage ();
	}
}

